function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useContext } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import sharedCss from "./sharedCss";
import { ValidityStateContext } from "./validityState";
export const InternalUseOnlyInput = styled.input.withConfig({
  componentId: "sc-cizuhu-0"
})(["", ";margin:0;&[type]{appearance:none;box-sizing:border-box;}"], sharedCss);

/**
 * The Input component allows users to input data into a form.
 */
const Input = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    validityState,
    small,
    readOnly,
    type = "text",
    name,
    pattern,
    min,
    max,
    required,
    minLength,
    maxLength,
    autoComplete,
    value,
    defaultValue,
    onChange,
    placeholder,
    ...props
  } = _ref;
  const validityStateContext = useContext(ValidityStateContext);
  return /*#__PURE__*/React.createElement(InternalUseOnlyInput, _extends({
    validityState: validityState ? validityState : validityStateContext,
    small,
    readOnly,
    type,
    name,
    pattern,
    min,
    max,
    required,
    minLength,
    maxLength,
    autoComplete,
    value,
    defaultValue,
    onChange,
    placeholder,
    ref
  }, props));
});
Input.displayName = "Input";
Input.propTypes = {
  /** The current validity state of the Input */
  validityState: PropTypes.oneOf(["error", "warning", "success", "unknown"]),
  /** A boolean indicating if the Input should be rendered in a smaller height */
  small: PropTypes.bool,
  /** A string representing the type of input to render */
  type: PropTypes.oneOf(["color", "date", "datetime-local", "email", "hidden", "month", "number", "password", "search", "tel", "text", "time", "url", "week"]),
  /** Used to reference the input in JavaScript, or to reference form data after a form is submitted */
  name: PropTypes.string,
  /** A JavaScript regular expression ex:(^[A-Z].*) */
  pattern: PropTypes.string,
  /** The input value must be greater than or equal to the min value */
  min: PropTypes.string,
  /** The input value must be less than or equal to the max value */
  max: PropTypes.string,
  /** Whether the input is required to be filled out to validate */
  required: PropTypes.bool,
  /** The number of characters must not be less than the minLength value */
  minLength: PropTypes.string,
  /** The number of characters must not exceed the maxLength value */
  maxLength: PropTypes.string,
  /** Specify what if any permission the user agent has to provide automated assistance in filling out form field values [docs](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete) */
  autoComplete: PropTypes.string,
  /** The value of the Input */
  value: PropTypes.string,
  /** Callback to execute when the value changes */
  onChange: PropTypes.func,
  /** Default value for uncontrolled use */
  defaultValue: PropTypes.string,
  /** Text that appears within the Input when empty */
  placeholder: PropTypes.string
};
export default Input;